import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import './styles.css';
import { sidebarLinksTop, sidebarLinksBottom } from '../../utils/nav';
import { ORGANISATION_SELECTOR } from '../../utils/types';
import SidebarItem from '../SidebarItem';
import Content from '../SidebarItem/Content';
import snukFull from '../../assets/snukFull.png';

const Sidebar = (props) => {
  const {
    t, resizeSidebar, isSidebarExtended, user,
  } = props;
  return (
    <div className={`sidebar-container ${isSidebarExtended ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
      <div>
        <ul className="nabvar-list-top">
          <li onClick={() => resizeSidebar()} className="hover sidebar-hide">
            <Content
              imgURL={snukFull}
              iconName={`chevron ${isSidebarExtended ? 'left' : 'right'}`}
              pageTitle={t('common.hide')}
              {...props}
            />
          </li>
          {sidebarLinksTop.map((item) => {
            if (item.view === 'all' || item.view.includes(user.role)) {
              return (
                <SidebarItem key={item.pageId} item={item} {...props} />
              );
            }
            return <Fragment key={item.pageId} />;
          })}
        </ul>
      </div>
      <div>
        <ul className="nabvar-list-bottom">
          {sidebarLinksBottom.map((item) => {
            if (item.view === 'all' || item.view.includes(user.role)) {
              if (user.organisationsId.length === 1 && item.pageId === ORGANISATION_SELECTOR) {
                // don't show the organisation selector if user belongs only to one organisation
                return <Fragment key={item.pageId} />;
              }
              return (
                <SidebarItem key={item.pageId} item={item} {...props} />
              );
            }
            return <Fragment key={item.pageId} />;
          })}
        </ul>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  t: PropTypes.func.isRequired,
  resizeSidebar: PropTypes.func.isRequired,
  isSidebarExtended: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    role: PropTypes.string.isRequired,
  }).isRequired,
};

export default translate()(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js